export default {
  namespaced: true,
  state: () => {
    return {
      // 实际投递由页面组件完成
      // 这个变量用来通知页面组件
      applyJobSignal: 0,

      // 单投参数
      applyOptions: {},

      // 批投信号
      batchApplyJobSignal: 0,
      // 批投参数
      batchApplyOptions: {},

      // 是否有投递动作
      applied: false,
    };
  },
  getters: {},
  mutations: {
    //给不同字段赋值,不缓存
    setValue(state, param) {
      Object.entries(param).forEach(([k, v]) => (state[k] = v));
    },
  },

  actions: {
    /**
     * 全平台单投
     * 仅支持网才职位
     * @param {object} ctx vuex context
     * @param {object} applyOptions
     * @param {object} applyOptions.item cupid 各种职位列表接口返回的职位信息对象
     * @param {object} applyOptions.property 投递埋点参数对象
     * @param {object} applyOptions.isShowToast 是否展示投递成功toast
     * @param {Function} applyOptions.onSuccess 投递成功时回调
     */
    async applyJob({ commit, state }, applyOptions) {
      commit("setValue", {
        applyJobSignal: state.applyJobSignal + 1,
        applyOptions,
        applied: true,
      });
    },

    /**
     * 全平台批投
     * 仅支持网才职位
     * @param {object} ctx vuex context
     * @param {object} batchApplyOptions
     * @param {Array} batchApplyOptions.jobList 一组 cupid 各种职位列表接口返回的职位信息对象
     * @param {object} batchApplyOptions.property 投递埋点参数对象
     * @param {Function} batchApplyOptions.onResult 投递结果回调
     */
    async batchApplyJob({ commit, state }, batchApplyOptions) {
      commit("setValue", {
        batchApplyJobSignal: state.batchApplyJobSignal + 1,
        batchApplyOptions,
        applied: true,
      });
    },
  },
};
